// src/components/AuthShell.js — centered logo + card layout for the signed-out
// account screens (forgot password, set password). Matches Login.js.
// centerHeader: centered, all-caps title with a centered subtitle (set-password screen).
export default function AuthShell({ title, subtitle, children, centerHeader = false }) {
  return (
    <div style={{
      minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center',
      padding: '24px', background: 'var(--bg)',
    }}>
      <div style={{ width: '100%', maxWidth: '380px', display: 'flex', flexDirection: 'column', alignItems: 'center', gap: '24px' }}>
        <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: '12px' }}>
          <div style={{
            width: '48px', height: '48px', background: '#3b82f6', borderRadius: '10px',
            display: 'flex', alignItems: 'center', justifyContent: 'center',
          }}>
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="white" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
              <path d="M22 12h-4l-3 9L9 3l-3 9H2"/>
            </svg>
          </div>
          <div style={{ textAlign: 'center' }}>
            <div style={{ fontSize: '18px', fontWeight: '700', color: 'var(--text-primary)', letterSpacing: '0.01em' }}>RGA CRM</div>
            <div style={{ fontSize: '11px', color: 'var(--text-muted)', fontWeight: '500', letterSpacing: '0.06em', textTransform: 'uppercase', marginTop: '4px' }}>
              Rainmaker Global
            </div>
          </div>
        </div>

        <div style={{
          width: '100%', background: 'var(--surface)', border: '1px solid var(--border)',
          borderRadius: 'var(--radius)', padding: '24px', display: 'flex', flexDirection: 'column', gap: '16px',
        }}>
          <div style={centerHeader ? { textAlign: 'center' } : undefined}>
            <h1 style={{
              fontSize: '16px', fontWeight: '600', color: 'var(--text-primary)',
              ...(centerHeader ? { textTransform: 'uppercase', letterSpacing: '0.06em' } : {}),
            }}>{title}</h1>
            {subtitle && <p style={{ marginTop: '4px', fontSize: '12px', color: 'var(--text-secondary)' }}>{subtitle}</p>}
          </div>
          {children}
        </div>
      </div>
    </div>
  )
}
